module.exports = __webpack_public_path__ + "static/banner-2e31df9ec4fd697fc401dd56c9e4207c.jpeg";